import client from './client'
import { Book } from '@/models'

export default {
  get: (params: { cd: string }) =>
    client.get<{ book: Book }>('get_book_data', { params }).then(({ data }) => data.book),
  set: (book: unknown) => client.post('set_book_data', { form: { book } }),

  shareByEmailTest: (params: { cd: string }) => client.get('send_book_mail_test', { params }).then(({ data }) => data),
  shareByEmail: ({ mailList, params }: { mailList: string; params: { cd: string } }) =>
    client.post('send_book_mail_list', { form: { mailList } }, { params }).then(({ data }) => data),

  remind: (params: { cd: string }) => client.get('send_book_mail_lockpass', { params }).then(({ data }) => data),
}
